"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeDoc = nodeDoc;
exports.nodeParagraph = nodeParagraph;
exports.nodeText = nodeText;
exports.nodeImage = nodeImage;
exports.nodeReference = nodeReference;
exports.markBold = markBold;
exports.markCode = markCode;
exports.markItalic = markItalic;
exports.markStrike = markStrike;
exports.markUnderline = markUnderline;
exports.markLink = markLink;
const model_1 = require("./model");
// Nodes
function nodeDoc(...content) {
    return node(model_1.MarkupNodeType.doc, ...content);
}
function nodeParagraph(...content) {
    return node(model_1.MarkupNodeType.paragraph, ...content);
}
function nodeText(text) {
    return { type: model_1.MarkupNodeType.text, text };
}
function nodeImage(attrs) {
    return { type: model_1.MarkupNodeType.image, attrs };
}
function nodeReference(attrs) {
    return { type: model_1.MarkupNodeType.reference, attrs };
}
// Marks
function markBold(node) {
    return withMarks(node, mark(model_1.MarkupMarkType.bold));
}
function markCode(node) {
    return withMarks(node, mark(model_1.MarkupMarkType.code));
}
function markItalic(node) {
    return withMarks(node, mark(model_1.MarkupMarkType.em));
}
function markStrike(node) {
    return withMarks(node, mark(model_1.MarkupMarkType.strike));
}
function markUnderline(node) {
    return withMarks(node, mark(model_1.MarkupMarkType.underline));
}
function markLink(attrs, node) {
    return withMarks(node, mark(model_1.MarkupMarkType.link, attrs));
}
// Utility
function node(type, ...content) {
    return { type, content };
}
function mark(type, attrs) {
    return { type, attrs: attrs ?? {} };
}
function withMarks(node, ...marks) {
    const current = node.marks ?? [];
    current.push(...marks);
    return { ...node, marks: current };
}
//# sourceMappingURL=dsl.js.map